<template>
	<div class="card m-1">
		<div class="card-header h4">
			{{item.nev}} - {{item.rszam}} - {{item.kidatum | toDate}} - {{item.osszeg}} Ft
 			<span class="float-right">
				<button
					class="btn btn-outline-success"
					@click.prevent="invoice_rend"
				>
					Kiszámláztam
				</button>
			</span>
		</div>
		<div class="card-body">
			<div class="row">
				<div
					class="col-12 h5"
					v-for="(rend,index) in item.list"
					:key="`rend-${index}`"
				>
					<div class="row">
						<div class="col-6">
							{{rend.tetel}}
						</div>
						<div class="col-2">
							{{rend.db}} db
						</div>
						<div class="col-2">
							{{rend.ar}} Ft / db
						</div>
						<div class="col-2">
							{{rend.db * rend.ar}} Ft
						</div>
					</div>
				</div>	
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'order_list_item',
	props: ['item'],
	computed: {
		rend_sum(){
			return this.item.list.reduce((total, current) => total + (~~current.ar * ~~current.db), 0)
		}
	},
	methods: {
		invoice_rend(){
			this.$Progress.start()
			this.req.post(`/orders/invoice_rend`,{
				rszam: this.item.rendelesszam
			})
				.then(res => {
					toastr.success(`Mentés sikeres`)
				  	this.$Progress.finish()
				})
				.catch(err => {
					console.log(err)
					toastr.error(`Mentés sikertelen`)
					this.$Progress.fail()
				})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/order_list/order_list_item.vue